// GAVION commissions: the company page « Abonnement » and the deal page « Étapes de la vente ».
export const commissionsClientEn = {
  subscription: {
    title: "Subscription",
    none: "No subscription.",
    create: "Create the subscription",
    new_subscription: "New subscription",
    scheduled: "From %{month}: %{plan}",
    change: "Change the package",
    cancel: "Cancel",
    add_exception: "Add an exception",
    add_fee: "Add a fee",
    plan: "Package",
    billing: "Billing",
    addons: "Add-ons",
    no_addons: "No add-on",
    services: "Recurring services",
    no_services: "No recurring service",
    add_service: "Add a recurring service",
    remove_service: "Remove recurring service %{n}",
    mrr: "MRR this month",
    first_paid_month: "First paid month",
    month_number: "Subscription month",
    cancelled: "Cancelled — last month billed: %{month}",
    periods: "Package history",
    exceptions: "Exceptions",
    fees: "One-time fees (no commission)",
    none_yet: "None.",
    from_month: "from %{month}",
    annual_paid: "%{amount} paid for the year",
    delete: "Delete",
    delete_exception: "Delete the exception of %{month}",
    delete_fee: "Delete the fee of %{month}",
    saved: "Subscription saved",
    confirm_cancel: "Cancel this subscription after %{month}?",
    suggestion: "Suggestion: %{amount} (annual discount %{pct} %)",
    stripe_badge: "Stripe",
    stripe_link: "View in Stripe",
    stripe_managed:
      "Managed by Stripe: package, price, billing, dates and cancellation are changed in Stripe (the sync applies them here).",
    submit_create: "Create",
    submit_change: "Save",
    close: "Cancel",
    origin: {
      legend:
        "This client had a cancelled subscription (last billed month: %{month}). This new subscription is:",
      resume: "Resume",
      resume_hint:
        "The client came back by himself: the month count continues the old subscription's (the plan rate does not restart at month 1) and the commissions go to the people of the original deal.",
      new: "New sale",
      new_hint:
        "A rep brought him back: a new deal, with its own sale steps; month 1 for the new people.",
    },
    fields: {
      deal: "Opportunity",
      package: "Package",
      billing: "Billing",
      first_month: "First paid month",
      from_month: "From the month",
      addon_qty: "%{name} (quantity)",
      services:
        "Recurring services (integrations, new products: in the commission base)",
      service_name: "Recurring service %{n}: name",
      service_amount: "Recurring service %{n}: amount ($ per month)",
      annual_amount: "Annual amount paid ($)",
      note: "Note",
      month: "Month",
      kind: "Exception",
      amount_collected: "Amount collected ($)",
      amount: "Amount ($)",
      ended_month: "Last month billed",
    },
    errors: {
      required: "Required.",
      month: "Choose a month.",
      amount: "Invalid amount.",
      qty: "Quantity: a whole number.",
      service:
        "Each recurring service: a name and a monthly amount between 0 and 100,000.",
      long: "Text too long.",
      new_deal:
        "This deal already has a subscription: a « New sale » needs a new deal.",
    },
  },
  sale_steps: {
    title: "Sale steps",
    setter: "Setter (appointment)",
    demo_by: "Demo by",
    demo_by_default: "%{name} (default: the Closer)",
    demo_by_default_setter: "%{name} (default: the setter, no Closer)",
    closer: "Closer (negotiation and signature)",
    source: "Sale source",
    appointment_at: "Appointment recorded on",
    demo_held_at: "Demo held on",
    override: "Override",
    override_value: "share %{pct} %",
    override_setter_value: "setter %{pct} %",
    undecided:
      "To decide: the contract does not settle this split (art. 4.5.6). Enter the agreed share of the Closer (and of the setter if he obtained the appointment and did the demo) in the override; until then, these months are on no statement (neither paid nor lost) and go on the next statement once the split is recorded.",
    edit: "Edit the steps",
    save: "Save",
    cancel: "Cancel",
    saved: "Sale steps saved",
    locked: "Only an admin can change the sale steps.",
    fields: {
      demo_by: "Demo by",
      source: "Sale source",
      appointment_at: "Appointment recorded on",
      override_pct: "Override: the Closer's share (%)",
      override_setter_pct: "Override: the setter's share (%)",
      override_note: "Reason for the override",
    },
    errors: {
      pct: "Enter a percentage between 0 and 100.",
      date: "Invalid date.",
      long: "Text too long.",
      needs_closer: "Enter the Closer's share first.",
      sum: "Together, the Closer's and the setter's shares cannot exceed 100 %.",
    },
    refusals: {
      sale_steps_admin_only:
        "Only an admin can change the sale steps (%{detail}).",
      invalid_role_holder:
        "This role must be given to an active user (%{detail}).",
    },
    roles: { account_manager: "Account manager", referrer: "Referrer" },
  },
  won_prompt: {
    text: "Opportunity won: create the client's subscription (package, add-ons, billing, first paid month).",
    create: "Create the subscription",
  },
};
